import { Injectable } from '@angular/core';
import { IMachineType } from 'projects/common/src/app/interfaces/machine-type';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { WidgetProviderService } from '../widget-provider.service';
import { Subject } from 'rxjs';
import { IShift } from 'src/app/modules/core/interfaces';
import { IDashboardParams } from '../../interfaces/dashboard-params';
import { IDashboardConfiguration } from 'src/app/modules/widget/interfaces/widget';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  public dashboardParams: IDashboardParams;
  public shift$: Subject<IShift>;
  public machineContext$: Subject<IMachineContext>;

  constructor(
    private parameterHandlerService: ParameterHandlerService,
    private widgetProvider: WidgetProviderService,
    private machineContextService: MachineContextService,
  ) {
    this.shift$ = new Subject<IShift>();
    this.machineContext$ = new Subject<IMachineContext>();

    this.dashboardParams = {
      date: null,
      machineContext: null,
      machineTypes: [],
      shift: null,
      shiftCollection: [],
    };
  }

  /**
   * Function to initialize dashboard params
   */
  public initializeDashboard(): void {
    this.initializeMachineTypes();
  }

  public getDashboardConfiguration(): Promise<IDashboardConfiguration> {
    // TODO Widget provider deberá proveer configuración para variados dashboard
    // TODO ``dsh`` es el por defecto por ahora
    return this.widgetProvider.getConfiguration('dsh');
  }

  /**
   * Function to initialize machineTypes for dashboard
   */
  private initializeMachineTypes() {
    this.parameterHandlerService.parameterSource.item('machine-collection').subscribe((machineCollection: IMachineType[]) => {
      this.dashboardParams.machineTypes = machineCollection;
    });

    this.machineContextService.getObservable().subscribe((machineContext: IMachineContext) => {
      // Busco en el listado seteado desde el params.machineTypes y lo convierto a MachineContext
      const machineContextFiltered = this.dashboardParams.machineTypes.find(
        (machine) => machine?.name?.toLowerCase() === machineContext?.name?.toLowerCase(),
      ) as IMachineContext;

      if (machineContextFiltered) {
        this.dashboardParams.machineContext = machineContextFiltered;
        this.machineContext$.next(machineContextFiltered);
      } else {
        console.error('Machine context not found');
      }
    });
  }
}
